import type * as React from "react"
import styled, { css } from "@digits-css"
import { isDigitsMacApp } from "@digits-shared/helpers/devicesHelper"
import borders from "@digits-shared/themes/borders"
import fonts from "@digits-shared/themes/typography"

export const SITE_WIDTH = 1200
export const SITE_CENTER_CONTENT_PADDING = 145
export const SITE_CENTER_CONTENT_WIDTH = SITE_WIDTH - SITE_CENTER_CONTENT_PADDING * 2

export const PAGE_HEADER_HEIGHT = isDigitsMacApp ? 140 : 152

export const CENTERED_DIALOG_CONTAINER_HEIGHT = "700px"
export const CENTERED_DIALOG_CONTAINER_WIDTH = "460px"

export interface CenteredDialogContainerProps {
  width?: string
  height?: string
  children?: React.ReactNode
}

export const CENTERED_DIALOG_CONTAINER_PARENT_STYLES = css`
  .desktop & {
    padding: 80px 20px 0 20px;
    @media only screen and (max-height: 800px) {
      padding-top: 50px;
    }
  }
  .mobile & {
    padding-top: 50px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
`

export const CenteredDialogContainer = styled.section<CenteredDialogContainerProps>`
  color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: ${fonts.weight.normal};
  font-size: 20px;
  height: ${({ height }) => height ?? CENTERED_DIALOG_CONTAINER_HEIGHT};
  width: ${({ width }) => width ?? CENTERED_DIALOG_CONTAINER_WIDTH};
  max-width: ${({ width }) => width ?? CENTERED_DIALOG_CONTAINER_WIDTH};
  box-sizing: content-box;

  .mobile & {
    height: auto;
    width: 100%;
  }

  background:
    radial-gradient(50% 40% at 50% 0%, rgba(24, 81, 114, 0.35) 0%, rgba(18, 53, 63, 0) 100%),
    radial-gradient(50% 20% at 50% 100%, #02273566 0%, #12353f00 100%) rgb(8 26 42);
  box-shadow: rgb(15, 42, 68) 0 0 1000px;

  backdrop-filter: blur(3px);
  border-radius: ${borders.radius.card}px;

  // back to IE6
  :root:not(.safari) {
    border: 0.5px solid transparent;
  }
  border-image: linear-gradient(55deg, #071a23, #0b7d83, #081231, #06bde2, #070f27);
  border-image-slice: 1;
  border-image-width: 1px;
`
